import React from 'react'
import {Icon} from '@chakra-ui/react'

const ExclamationIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                d="M12 1C5.93 1 1 5.93 1 12C1 18.07 5.93 23 12 23C18.07 23 23 18.07 23 12C23 5.93 18.07 1 12 1ZM12 21C7.04 21 3 16.96 3 12C3 7.04 7.04 3 12 3C16.96 3 21 7.04 21 12C21 16.96 16.96 21 12 21Z"
                fill="currentColor"
            />
            <path
                d="M12 13C12.55 13 13 12.55 13 12V8C13 7.45 12.55 7 12 7C11.45 7 11 7.45 11 8V12C11 12.55 11.45 13 12 13Z"
                fill="currentColor"
            />
            <path
                d="M12.01 15H12C11.45 15 11 15.45 11 16C11 16.55 11.45 17 12.01 17C12.57 17 13.01 16.55 13.01 16C13.01 15.45 12.56 15 12.01 15Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ExclamationIcon
